module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-9313801f5e14eefc8e6597fbc0592ee9.png";